import { gql } from 'graphql-request';

export const siteFilesQuery = gql`
    query getSiteFiles($projectId: String!) {
        projectDefinition: getProjectSummary(projectId: $projectId) {
            files(fileType: "reports") {
                name
                awsFileKey
                createdAt
            }
            projectName
        }
    }
`;

export type SiteFile = {
    name: string;
    awsFileKey: string;
    createdAt?: string;
};

export type SiteFilesQueryResult = {
    projectDefinition: {
        projectName: string;
        files: SiteFile[];
    };
};
